import { render, staticRenderFns } from "./AdminChapter_questions.vue?vue&type=template&id=47bafa16&"
import script from "./AdminChapter_questions.vue?vue&type=script&lang=js&"
export * from "./AdminChapter_questions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports